function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.518 3.552a4.91 4.91 0 00-7.036 0c-1.938 1.976-1.938 5.175 0 7.151l2.917 2.976c.334.34.868.34 1.202 0l.668-.682.013-.013 2.236-2.28c1.938-1.977 1.938-5.176 0-7.152zm-7.758-.76a5.912 5.912 0 018.48 0c2.347 2.393 2.347 6.278 0 8.671L9.322 14.44a1.838 1.838 0 01-2.644 0L3.76 11.463c-2.347-2.393-2.347-6.278 0-8.671zM8 5.562c-.86 0-1.543.71-1.543 1.566 0 .856.683 1.564 1.543 1.564.86 0 1.543-.708 1.543-1.564 0-.856-.683-1.565-1.543-1.565zM5.429 7.129c0-1.462 1.159-2.632 2.571-2.632 1.412 0 2.571 1.17 2.571 2.632 0 1.46-1.159 2.63-2.571 2.63-1.412 0-2.571-1.17-2.571-2.63z",
  fill: "#2D2D2D"
});
function SvgUbicacin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Ubicación.svg";
export { SvgUbicacin as ReactComponent };